import { useEffect, useState } from "react";
import api from "@/api";
import { toast } from "sonner";

export function AdminReviews() {
  const [items, setItems] = useState(null);
  const [status, setStatus] = useState("");
  const [replyFor, setReplyFor] = useState(null);
  const [reply, setReply] = useState("");
  const load = () => api.get("/admin/reviews", { params: { status } }).then(({ data }) => setItems(data));
  useEffect(() => { load(); }, [status]);
  const act = async (id, payload, msg) => { await api.put(`/admin/reviews/${id}`, payload); toast.success(msg); load(); };
  const del = async (id) => { if (!window.confirm("Delete review?")) return; await api.delete(`/admin/reviews/${id}`); load(); };
  return (
    <div data-testid="admin-reviews">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <h1 className="font-serif text-3xl">Reviews</h1>
        <select value={status} onChange={(e) => setStatus(e.target.value)} data-testid="reviews-status-filter" className="tq-input !py-2 !w-auto bg-white">
          <option value="">All</option><option value="pending">Pending</option><option value="approved">Approved</option><option value="rejected">Rejected</option>
        </select>
      </div>
      {!items ? <div className="h-48 bg-white animate-pulse" /> : items.length === 0 ? (
        <div className="bg-white border border-[#E5DEC9] p-12 text-center text-[#6E6D6A]" data-testid="reviews-empty">No reviews {status && `with status "${status}"`}.</div>
      ) : (
        <div className="space-y-3">
          {items.map((r) => (
            <div key={r.id} className="bg-white border border-[#E5DEC9] p-4" data-testid={`review-row-${r.id}`}>
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div>
                  <span className="text-[#D4AF37]">{"★".repeat(r.rating)}{"☆".repeat(5 - r.rating)}</span>
                  <span className="ml-3 font-medium text-sm">{r.product_name}</span>
                  <span className="ml-2 text-xs text-[#9a938a]">by {r.name}{r.verified_purchase && " · ✓ Verified"}</span>
                </div>
                <span className={`text-[10px] font-bold uppercase px-2 py-1 ${r.status === "approved" ? "bg-[#1A3C34]/10 text-[#1A3C34]" : r.status === "pending" ? "bg-[#D4AF37]/15 text-[#8C7A5E]" : "bg-[#8B1E21]/10 text-[#8B1E21]"}`}>{r.status}</span>
              </div>
              <p className="text-sm text-[#444] mt-2">{r.body}</p>
              {r.reply && <p className="text-sm mt-2 pl-3 border-l-2 border-[#D4AF37] text-[#6E6D6A]">Your reply: {r.reply}</p>}
              <div className="flex flex-wrap gap-3 mt-3 text-xs font-semibold">
                {r.status !== "approved" && <button onClick={() => act(r.id, { status: "approved" }, "Review approved")} data-testid={`review-approve-${r.id}`} className="text-[#1A3C34]">Approve</button>}
                {r.status !== "rejected" && <button onClick={() => act(r.id, { status: "rejected" }, "Review rejected")} data-testid={`review-reject-${r.id}`} className="text-[#8B1E21]">Reject</button>}
                <button onClick={() => { setReplyFor(r.id); setReply(r.reply || ""); }} data-testid={`review-reply-${r.id}`} className="text-[#C5A059]">Reply</button>
                <button onClick={() => del(r.id)} className="text-[#8B1E21]">Delete</button>
              </div>
              {replyFor === r.id && (
                <div className="flex gap-2 mt-3">
                  <input value={reply} onChange={(e) => setReply(e.target.value)} placeholder="Reply as TARISHQ…" data-testid="review-reply-input" className="tq-input flex-1 !py-2" />
                  <button onClick={() => { act(r.id, { reply }, "Reply saved"); setReplyFor(null); }} data-testid="review-reply-save" className="tq-btn-dark !py-2">Save</button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export function AdminNotify() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/notify-requests").then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);
  return (
    <div data-testid="admin-notify">
      <h1 className="font-serif text-3xl mb-6">Back-in-Stock Requests</h1>
      {!items ? <div className="h-48 bg-white animate-pulse" /> : items.length === 0 ? (
        <div className="bg-white border border-[#E5DEC9] p-12 text-center text-[#6E6D6A]">No notify-me requests yet.</div>
      ) : (
        <div className="bg-white border border-[#E5DEC9] overflow-x-auto">
          <table className="w-full text-sm min-w-[560px]">
            <thead><tr className="text-left text-[10px] uppercase tracking-[0.15em] text-[#8C7A5E] border-b border-[#E5DEC9]">
              <th className="p-3">When</th><th className="p-3">Product</th><th className="p-3">Size</th><th className="p-3">Contact</th>
            </tr></thead>
            <tbody>
              {items.map((r) => (
                <tr key={r.id} className="border-b border-[#F4EFE6]">
                  <td className="p-3 text-xs">{new Date(r.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short" })}</td>
                  <td className="p-3">{r.product_name}</td>
                  <td className="p-3">{r.size || "—"}</td>
                  <td className="p-3">{r.email || r.phone}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
